import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { ksDigitalDarkTheme, ksDigitalLightTheme } from './ksDigitalTheme';
// Backstage UI (BUI) styres med CSS-variabler, ikke MUI-temaet. Må importeres etter
// @backstage/ui/css/styles.css (lastes i index.tsx) for å overstyre standardverdiene.
import './ksDigital.css';

/**
 * Overstyrer de innebygde temaene `theme:app/light` og `theme:app/dark` ved å
 * bruke samme navn. Da virker temavelgeren i Backstage og brukernes lagrede
 * valg som før, og KS Digital-temaet er standard.
 */
const ksLight = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'KS Digital lys',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={ksDigitalLightTheme} children={children} />
      ),
    },
  },
});

const ksDark = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'KS Digital mørk',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={ksDigitalDarkTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [ksLight, ksDark],
});
